var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlowerOffHeaterOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Blower_OFF_Heater_OFF",
    "data-name": "Blower OFF_Heater OFF",
    xmlns: "http://www.w3.org/2000/svg",
    width: 508,
    height: 48,
    viewBox: "0 0 508 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9857",
    "data-name": "Group 9857"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9856",
    "data-name": "Group 9856"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9855",
    "data-name": "Group 9855"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9854",
    "data-name": "Group 9854"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3880",
    "data-name": "Path 3880",
    d: "M9.36,39.58,4.3,34.46l5.06-5.12H5.06L0,34.46l5.06,5.12Z",
    fill: "#6a7084"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3881",
    "data-name": "Path 3881",
    d: "M427.51,38.76h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.45,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.45,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.45,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.45,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.45,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.45,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.45,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11H260Zm-6.44,0h-3.22V30.11h3.22Zm-6.45,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.45,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.44,0H198.8V30.11h3.22Zm-6.45,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.45,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.44,0H153.7V30.11h3.22Zm-6.45,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.45,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.44,0h-3.22V30.11h3.22Zm-6.44,0H108.6V30.11h3.22Zm-6.45,0h-3.22V30.11h3.22Zm-6.44,0H95.71V30.11h3.22Zm-6.44,0H89.27V30.11h3.22Zm-6.44,0H82.83V30.11h3.22Zm-6.45,0H76.38V30.11H79.6Zm-6.44,0H69.94V30.11h3.22Zm-6.44,0H63.5V30.11h3.22Zm-6.45,0H57.05V30.11h3.22Zm-6.44,0H50.61V30.11h3.22Zm-6.44,0H44.17V30.11h3.22Zm-6.44,0H37.73V30.11h3.22Zm-6.45,0H31.28V30.11H34.5Zm-6.44,0H24.84V30.11h3.22Zm-6.44,0H18.4V30.11h3.22v8.65Zm-6.45,0H11.95V30.11h3.22Z",
    fill: "#6a7084"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9877",
    "data-name": "Group 9877"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9876",
    "data-name": "Group 9876"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9875",
    "data-name": "Group 9875"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9858",
    "data-name": "Group 9858"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3882",
    "data-name": "Path 3882",
    d: "M506.38.33h-24.9a1.306,1.306,0,0,0-1.3,1.31V6.81a20.906,20.906,0,0,0-13.12,13.77h-6.93a1.306,1.306,0,0,0-1.3,1.31V46.36a1.3,1.3,0,0,0,1.3,1.31H486.1v-.04c.28.01.55.04.82.04a20.883,20.883,0,0,0,20.75-21.01c0-.24-.03-.48-.04-.72h.04V1.64A1.291,1.291,0,0,0,506.38.33Z",
    fill: "#6a7084"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3883",
    "data-name": "Path 3883",
    d: "M486.92,48c-.18,0-.35-.01-.52-.02a.22.22,0,0,1-.08-.01l-.22.03H460.13a1.637,1.637,0,0,1-1.62-1.64V21.89a1.637,1.637,0,0,1,1.62-1.64h6.69A21.255,21.255,0,0,1,479.86,6.58V1.64A1.63,1.63,0,0,1,481.48,0h24.9A1.637,1.637,0,0,1,508,1.64l-.02,24.63c.01.13.02.26.02.39A21.236,21.236,0,0,1,486.92,48Zm-.81-.7c.11,0,.22.01.33.02.16.01.32.02.48.02a20.585,20.585,0,0,0,20.43-20.68c0-.13-.01-.27-.02-.4-.01-.1-.01-.21-.02-.31l-.01-.34h.05V1.64a.98.98,0,0,0-.97-.98h-24.9a.973.973,0,0,0-.97.98v5.4l-.22.08a20.608,20.608,0,0,0-12.92,13.55l-.07.23h-7.17a.973.973,0,0,0-.97.98V46.35a.98.98,0,0,0,.97.98Z",
    fill: "#404041"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9874",
    "data-name": "Group 9874"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9861",
    "data-name": "Group 9861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9859",
    "data-name": "Group 9859"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3884",
    "data-name": "Path 3884",
    d: "M484.5,41.67a3.053,3.053,0,0,1-2.01-.61,1.935,1.935,0,0,1-.68-1.46,18.924,18.924,0,0,1,3-10.69c.51-.99,1.07-1.48,1.69-1.48,1.02,0,1.62,1.39,1.69,1.55l3,4.64a3.825,3.825,0,0,1-.03,4.53,6.634,6.634,0,0,1-.94,1.02,9.366,9.366,0,0,1-4.66,2.41,6.891,6.891,0,0,1-1.06.09Z",
    fill: "#8b90a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9860",
    "data-name": "Group 9860"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3885",
    "data-name": "Path 3885",
    d: "M486.5,27.76c.83,0,1.38,1.34,1.38,1.34l3.03,4.7a3.532,3.532,0,0,1,0,4.14,6.315,6.315,0,0,1-.92.99,8.909,8.909,0,0,1-4.5,2.32,6.273,6.273,0,0,1-1,.09,2.764,2.764,0,0,1-1.8-.53,1.652,1.652,0,0,1-.56-1.22,18.841,18.841,0,0,1,2.94-10.49c.52-1,1.01-1.34,1.43-1.34m0-.65c-.75,0-1.4.54-1.98,1.66a19.312,19.312,0,0,0-3.03,10.85,2.276,2.276,0,0,0,.8,1.69,3.421,3.421,0,0,0,2.22.68,6.35,6.35,0,0,0,1.11-.1,9.54,9.54,0,0,0,4.83-2.49,7.184,7.184,0,0,0,1-1.08,4.169,4.169,0,0,0,.04-4.86l-3.01-4.67c-.17-.33-.84-1.68-1.98-1.68Z",
    fill: "#404041"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9864",
    "data-name": "Group 9864"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9862",
    "data-name": "Group 9862"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3886",
    "data-name": "Path 3886",
    d: "M486.5,23.56c-1.02,0-1.62-1.39-1.69-1.55l-3-4.64a3.825,3.825,0,0,1,.03-4.53,6.634,6.634,0,0,1,.94-1.02,9.266,9.266,0,0,1,4.66-2.4,6.669,6.669,0,0,1,1.05-.09,3.053,3.053,0,0,1,2.01.61,1.935,1.935,0,0,1,.68,1.46,18.924,18.924,0,0,1-3,10.69q-.735,1.47-1.68,1.47Z",
    fill: "#8b90a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9863",
    "data-name": "Group 9863"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3887",
    "data-name": "Path 3887",
    d: "M488.5,9.65a2.764,2.764,0,0,1,1.8.53,1.652,1.652,0,0,1,.56,1.22,18.841,18.841,0,0,1-2.94,10.49c-.52,1.01-1,1.34-1.42,1.34-.83,0-1.38-1.34-1.38-1.34l-3.03-4.7a3.532,3.532,0,0,1,0-4.14,6.315,6.315,0,0,1,.92-.99,8.909,8.909,0,0,1,4.5-2.32,6.258,6.258,0,0,1,.99-.09m0-.65a6.35,6.35,0,0,0-1.11.1,9.54,9.54,0,0,0-4.83,2.49,7.7,7.7,0,0,0-1,1.08,4.169,4.169,0,0,0-.04,4.86l3.01,4.67c.15.34.82,1.69,1.97,1.69.75,0,1.4-.54,1.98-1.66a19.193,19.193,0,0,0,3.03-10.85,2.276,2.276,0,0,0-.8-1.69A3.322,3.322,0,0,0,488.5,9Z",
    fill: "#404041"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9867",
    "data-name": "Group 9867"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9865",
    "data-name": "Group 9865"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3888",
    "data-name": "Path 3888",
    d: "M476.05,31.08a3.482,3.482,0,0,1-2.19-.73,6.2,6.2,0,0,1-1.02-.94,9.179,9.179,0,0,1-2.41-4.65,3.75,3.75,0,0,1,.51-3.05,1.987,1.987,0,0,1,1.46-.68c.24-.01.47-.02.71-.02a19.167,19.167,0,0,1,10.02,3.01c1,.51,1.52,1.1,1.49,1.73-.04.99-1.4,1.57-1.55,1.63l-4.66,2.99a4.536,4.536,0,0,1-2.36.71Z",
    fill: "#8b90a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9866",
    "data-name": "Group 9866"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3889",
    "data-name": "Path 3889",
    d: "M473.1,21.34a19.047,19.047,0,0,1,9.83,2.95c3.03,1.55,0,2.8,0,2.8l-4.71,3.02a4.3,4.3,0,0,1-2.17.65,3.208,3.208,0,0,1-1.98-.65,7.3,7.3,0,0,1-1-.91,8.864,8.864,0,0,1-2.33-4.48,3.387,3.387,0,0,1,.44-2.79,1.652,1.652,0,0,1,1.22-.56c.25-.02.48-.03.7-.03m0-.65c-.24,0-.48.01-.72.02a2.3,2.3,0,0,0-1.7.8,4.007,4.007,0,0,0-.58,3.31,9.629,9.629,0,0,0,2.49,4.82,6.993,6.993,0,0,0,1.08.99,3.869,3.869,0,0,0,2.37.78,4.937,4.937,0,0,0,2.51-.74l4.69-3c.38-.17,1.65-.8,1.7-1.9.03-.76-.53-1.45-1.67-2.04a19.606,19.606,0,0,0-10.17-3.04Z",
    fill: "#404041"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9870",
    "data-name": "Group 9870"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9868",
    "data-name": "Group 9868"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3890",
    "data-name": "Path 3890",
    d: "M496.95,31.29a4.6,4.6,0,0,1-2.34-.69l-4.72-3.03c-.1-.04-1.46-.62-1.5-1.61-.03-.63.49-1.22,1.52-1.75a19.2,19.2,0,0,1,9.98-2.98c.23,0,.47,0,.71.02a1.987,1.987,0,0,1,1.46.68,3.675,3.675,0,0,1,.51,3.05,9.257,9.257,0,0,1-2.41,4.65,7.031,7.031,0,0,1-1.05.96A3.533,3.533,0,0,1,496.95,31.29Z",
    fill: "#8b90a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9869",
    "data-name": "Group 9869"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3891",
    "data-name": "Path 3891",
    d: "M499.9,21.55c.23,0,.46.01.69.02a1.652,1.652,0,0,1,1.22.56,3.312,3.312,0,0,1,.44,2.79,8.865,8.865,0,0,1-2.33,4.48,5.845,5.845,0,0,1-1,.91,3.208,3.208,0,0,1-1.98.65,4.206,4.206,0,0,1-2.17-.65l-4.71-3.02s-3.03-1.24,0-2.8a19.255,19.255,0,0,1,9.84-2.94m0-.65h0a19.646,19.646,0,0,0-10.17,3.04c-1.14.59-1.7,1.28-1.67,2.04.05,1.1,1.31,1.73,1.7,1.9l4.66,2.99a4.951,4.951,0,0,0,2.53.75,3.869,3.869,0,0,0,2.37-.78,7.046,7.046,0,0,0,1.08-.99,9.511,9.511,0,0,0,2.49-4.82,4.044,4.044,0,0,0-.58-3.31,2.3,2.3,0,0,0-1.7-.8c-.24-.02-.48-.02-.71-.02Z",
    fill: "#404041"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9873",
    "data-name": "Group 9873"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9871",
    "data-name": "Group 9871"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3892",
    "data-name": "Path 3892",
    d: "M486.45,28.3a2.8,2.8,0,1,1,2.81-2.8A2.8,2.8,0,0,1,486.45,28.3Zm0-3.64a.837.837,0,0,0-.84.83.84.84,0,1,0,.84-.83Z",
    fill: "#8b90a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9872",
    "data-name": "Group 9872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3893",
    "data-name": "Path 3893",
    d: "M486.45,23.03a2.47,2.47,0,1,1-2.48,2.47,2.477,2.477,0,0,1,2.48-2.47m0,3.63a1.16,1.16,0,1,0-1.17-1.16,1.169,1.169,0,0,0,1.17,1.16m0-4.28a3.12,3.12,0,1,0,3.13,3.12,3.126,3.126,0,0,0-3.13-3.12Zm0,3.63a.51.51,0,1,1,.51-.51.512.512,0,0,1-.51.51Z",
    fill: "#404041"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlowerOffHeaterOff);
export default __webpack_public_path__ + "static/media/blower_off_heater_off.8cfe114dc19b3f661bfa39c138d5c622.svg";
export { ForwardRef as ReactComponent };